<script>

    import { createEventDispatcher } from 'svelte'
    import ProvidersMethods from '../$methods/providers.methods'

    const dispatch = createEventDispatcher()

    export let provider = ''
    export let label = 'Proveedor'
    export let hideLabels = false
    export let size = ''

    const providers = ProvidersMethods.getProviders()

    function onSelect() {
        dispatch('select')
    }

</script>
<!-- svelte-ignore a11y-no-onchange -->
 
<div class="field">
    {#if !hideLabels}
        <label for="" class="label">{ label }</label>
    {/if}
    <div class="control">
        <div class="select is-fullwidth" class:is-small={size === 'small'}>
            <select bind:value={provider} on:change={onSelect}>
                <option value="">Proveedor</option>
                {#each providers as providerItem}
                    <option value="{ providerItem }">{ providerItem }</option>
                {/each}
            </select>
        </div>
    </div>
</div>